import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Info } from 'lucide-react';

const Widerruf = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-sky-50 via-white to-indigo-50 p-4 pt-24">
            <div className="max-w-4xl mx-auto">
                <Link
                    to="/"
                    className="inline-flex items-center text-gray-600 hover:text-indigo-600 mb-6 transition-colors"
                >
                    <ArrowLeft className="w-4 h-4 mr-1" />
                    Zurück zur Startseite
                </Link>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/60 p-8 md:p-12"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <Info className="w-8 h-8 text-indigo-600" />
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Widerrufsbelehrung</h1>
                    </div>

                    <div className="prose prose-indigo max-w-none text-gray-700 space-y-6">

                        <section>
                            <h2 className="text-xl font-semibold mt-6">1. Gesetzliches Widerrufsrecht</h2>
                            <p>
                                Verbrauchern steht bei Fernabsatzverträgen grundsätzlich ein gesetzliches Widerrufsrecht von <strong>14 Tagen</strong> ab Vertragsschluss zu.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold mt-6">2. Erlöschen des Widerrufsrechts bei digitalen Dienstleistungen</h2>
                            <p>
                                <strong>Studytino Pro</strong> ist eine digitale Dienstleistung (Software as a Service – SaaS).
                            </p>
                            <p>
                                Bei digitalen Dienstleistungen beginnt die Leistungserbringung <strong>unmittelbar nach Vertragsschluss</strong>. Der Kunde stimmt auf der Upgrade-Seite ausdrücklich zu, dass die Leistung <strong>vor Ablauf der Widerrufsfrist</strong> beginnt.
                            </p>
                            <p>
                                Das Widerrufsrecht erlischt, sobald die digitale Leistung <strong>vollständig erbracht wurde</strong>.
                            </p>
                            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-xl my-4">
                                <p className="text-yellow-800 text-sm">
                                    ⚠️ <strong>Wichtig:</strong> Da die Bereitstellung von Studytino Pro unmittelbar nach Vertragsschluss beginnt und Sie dem vorzeitigen Beginn ausdrücklich zugestimmt haben, erlischt das Widerrufsrecht, sobald die Leistung vollständig erbracht wurde.
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold mt-6">3. Kündigung des Abonnements</h2>
                            <p>
                                Die Beendigung des Abonnements erfolgt durch <strong>Kündigung</strong> – nicht durch Widerruf.
                            </p>
                            <p>
                                Das Abonnement kann jederzeit über die dafür vorgesehene Kündigungsfunktion im <strong>Stripe Customer Portal</strong> gekündigt werden. Die Kündigung wird zum Ende des bereits bezahlten Abrechnungszeitraums wirksam. Bereits gezahlte Entgelte werden nicht anteilig erstattet, sofern keine gesetzliche Verpflichtung hierzu besteht.
                            </p>
                        </section>

                        <p className="text-sm text-gray-500 mt-8">Stand: Juli 2026</p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Widerruf;